import { useEffect, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../../contexts/AuthContext";
import { useStateContext } from "../../../../contexts/ContextProvider";
import { Loader } from "../../../../components";
import { postRequest } from "../../../../constants/api";
import { Container, Card, Form, Row, Col } from "react-bootstrap";
import {
  Box,
  Alert,
  Button,
  Snackbar,
  Autocomplete,
  TextField,
} from "@mui/material";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import SaveIcon from "@mui/icons-material/Save";
import useScreenWidth from "../../../../hooks/useScreenWidth";

const TambahKoreksiStokToko = () => {
  const screenSize = useScreenWidth();
  const { user, dispatch } = useContext(AuthContext);
  const [open, setOpen] = useState(false);
  const [validated, setValidated] = useState(false);
  const [inputTanggalKoreksiStokToko, setInputTanggalKoreksiStokToko] =
    useState(new Date());
  const [kodeBarang, setKodeBarang] = useState("");
  const [kuantitasStok, setKuantitasStok] = useState("");
  const [perubahanKuantitasStok, setPerubahanKuantitasStok] = useState("");
  const [harga, setHarga] = useState("");
  const [subtotalKoreksiStokToko, setSubtotalKoreksiStokToko] = useState("");
  const [keterangan, setKeterangan] = useState("");

  const [barangs, setBarangs] = useState([]);
  const [error, setError] = useState(false);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  let barangOptions = barangs.map((barang) => ({
    label: `${barang.kodeBarang} - ${barang.namaBarang}`,
  }));

  useEffect(() => {
    getBarangsData();
  }, []);

  const getBarangsData = async () => {
    const response = await postRequest(`/barangs`, {}, navigate, dispatch);
    setBarangs(response.data);
  };

  const getBarang = async (kodeBarang) => {
    if (kodeBarang.length === 0) {
      return;
    }
    let tempKodeBarang = kodeBarang.split(" -", 1)[0];
    const pickedBarang = await postRequest(
      `/stokTokosByKodeBarang`,
      { kodeBarang: tempKodeBarang },
      navigate,
      dispatch
    );
    if (pickedBarang.data) {
      setKuantitasStok(pickedBarang.data.kuantitasStok);
    }

    setKodeBarang(kodeBarang);

    const findBarangHpp = await postRequest(
      `/barangHppByStokTokoId/${pickedBarang.data.id}`,
      {
        tanggalKoreksiStokToko: inputTanggalKoreksiStokToko,
      },
      navigate,
      dispatch
    );
    console.log("findBarangHpp.data");
    console.log(findBarangHpp.data);
    if (findBarangHpp.data) {
      setHarga(findBarangHpp.data.hpp.toLocaleString("en-US"));
    } else {
      setHarga("0");
    }
  };

  const updateKuantitasKoreksiStokToko = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;
    if (form.checkValidity() && kodeBarang.length !== 0) {
      setLoading(true);
      try {
        setLoading(true);
        await postRequest(
          `/updateKuantitasKoreksiStokToko`,
          {
            tanggalKoreksiStokToko: inputTanggalKoreksiStokToko,
            kodeBarang: kodeBarang.split(" -", 1)[0],
            kuantitasStok,
            perubahanKuantitasStok,
            harga: harga.replace(/,/g, ""),
            subtotalKoreksiStokToko: subtotalKoreksiStokToko.replace(/,/g, ""),
            keterangan,
          },
          navigate,
          dispatch
        );
        setLoading(false);
        navigate("/koreksiStokToko");
      } catch (error) {
        if (error.response.status == 401) {
          dispatch({ type: "LOGOUT" });
          navigate("/");
        } else {
          alert(error.response.data.message);
        }
      }
      setLoading(false);
    } else {
      setError(true);
      setOpen(!open);
    }
    setValidated(true);
  };

  if (loading) {
    return <Loader />;
  }

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  return (
    <Container>
      <h3>Stok</h3>
      <h5 style={{ fontWeight: 400 }}>Tambah Koreksi Stok Toko</h5>
      <hr />
      <Card>
        <Card.Header>Koreksi Stok Toko</Card.Header>
        <Card.Body>
          <Form
            noValidate
            validated={validated}
            onSubmit={updateKuantitasKoreksiStokToko}
          >
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Tgl. Koreksi <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="8">
                    <DatePicker
                      required
                      dateFormat="dd/MM/yyyy"
                      selected={inputTanggalKoreksiStokToko}
                      customInput={<Form.Control required />}
                      onChange={(date) => {
                        setInputTanggalKoreksiStokToko(date);
                      }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Barang <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="8">
                    <Autocomplete
                      size="small"
                      disablePortal
                      id="combo-box-demo"
                      options={barangOptions}
                      renderInput={(params) => (
                        <TextField
                          error={error && kodeBarang.length === 0 && true}
                          size="small"
                          {...params}
                        />
                      )}
                      onInputChange={(e, value) => {
                        getBarang(value);
                      }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Stok Awal <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      required
                      type="number"
                      value={kuantitasStok}
                      disabled
                      readOnly
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Koreksi <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      required
                      type="number"
                      value={perubahanKuantitasStok}
                      onChange={(e) => {
                        setPerubahanKuantitasStok(e.target.value);

                        let tempSubtotal = Math.abs(
                          parseInt(harga.replace(/,/g, "")) *
                            parseInt(e.target.value)
                        );
                        setSubtotalKoreksiStokToko(
                          tempSubtotal.toLocaleString("en-US")
                        );
                      }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Stok Awal <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      required
                      type="number"
                      value={
                        parseInt(kuantitasStok) +
                        parseInt(perubahanKuantitasStok)
                      }
                      disabled
                      readOnly
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Harga <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      value={harga}
                      onChange={(e) => {
                        let tempNum;
                        let isNumNan = isNaN(
                          parseInt(e.target.value.replace(/,/g, ""), 10)
                        );
                        if (isNumNan) {
                          tempNum = "";
                        } else {
                          tempNum = parseInt(
                            e.target.value.replace(/,/g, ""),
                            10
                          ).toLocaleString("en-US");
                        }
                        setHarga(tempNum);

                        let tempSubtotal = Math.abs(
                          parseInt(tempNum.replace(/,/g, "")) *
                            parseInt(perubahanKuantitasStok)
                        );
                        setSubtotalKoreksiStokToko(
                          tempSubtotal.toLocaleString("en-US")
                        );
                      }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Subtotal <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      value={subtotalKoreksiStokToko}
                      onChange={(e) => {
                        let tempNum;
                        let isNumNan = isNaN(
                          parseInt(e.target.value.replace(/,/g, ""), 10)
                        );
                        if (isNumNan) {
                          tempNum = "";
                        } else {
                          tempNum = parseInt(
                            e.target.value.replace(/,/g, ""),
                            10
                          ).toLocaleString("en-US");
                        }
                        setSubtotalKoreksiStokToko(tempNum);
                      }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Keterangan :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      as="textarea"
                      rows={3}
                      value={keterangan}
                      onChange={(e) => {
                        setKeterangan(e.target.value.toUpperCase());
                      }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Box sx={spacingTop}>
              <Button
                variant="outlined"
                color="secondary"
                onClick={() => navigate("/koreksiStokToko")}
                sx={{ marginRight: 2 }}
              >
                {"< Kembali"}
              </Button>
              <Button
                variant="contained"
                startIcon={<SaveIcon />}
                type="submit"
              >
                Simpan
              </Button>
            </Box>
          </Form>
        </Card.Body>
      </Card>
      {error && (
        <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
          <Alert onClose={handleClose} severity="error" sx={alertBox}>
            Data belum terisi semua!
          </Alert>
        </Snackbar>
      )}
    </Container>
  );
};

export default TambahKoreksiStokToko;

const colorRed = {
  color: "red",
};

const spacingTop = {
  mt: 4,
};

const alertBox = {
  width: "100%",
};
